// extracted by mini-css-extract-plugin
export default {"map":"MoscowRegionMap_map__LJMcB"};